import {log, logError} from '../webUtils'

// Pas de notion d'instance ni de mission

const chatMessages = (state = [], action) => {
  switch (action.type) {
    case 'PUSH_CHAT_MESSAGE':
      return [
        ...state,
        {
          id: action.id,
          conversationId: action.conversationId,
          message: action.message,
          messageLocaleKey: action.messageLocaleKey,
          extraData: action.extraData,
          date:action.date,
          messageType: action.messageType,
          userProfileId:action.userProfileId,
          userHandlerId:action.userHandlerId,
          userId:action.userHandlerId,
        }
      ]
    case 'PUSH_CHAT_MESSAGE_LIST':
      return action.messages;
    case 'PUSH_SESSION_STATE':
      return action.state.chat;
    case 'SET_STATE_FROM_SERVER':
      if(typeof action.state.chats == 'undefined') {
        // throw new Error ('Undefined state.dongles from server.')
        return state;
      }
      else
        return action.state.chats;
    case 'SET_STATE_FROM_DATABASE':
      if(typeof action.state.chats === 'undefined') {
        // log ('Undefined "state.chats" from server.')
        return state;
      }
      else
        return action.state.chats;
    default:
      return state
  }
}

export default chatMessages
